import { ArrowUp } from 'lucide-react';
import { FaTwitter } from '@react-icons/all-files/fa/FaTwitter';
import { FaYoutube } from '@react-icons/all-files/fa/FaYoutube';
import React, { useState } from 'react';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';
import Contact from './Contact';

const Footer = () => {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showContact, setShowContact] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer className="bg-white pt-16 pb-8 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center mb-10">
          <div className="mb-6 md:mb-0">
            <a href="#" className="flex items-center space-x-2 mb-4">
              <span className="text-2xl font-bold bg-gradient-to-r from-up247-700 to-up247-500 bg-clip-text text-transparent">
                up247
              </span>
            </a>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-3 gap-8 sm:gap-16">
            <div>
              <h3 className="text-sm font-semibold text-gray-900 mb-4">Product</h3>
              <ul className="space-y-3">
                <li><a href="#features" className="text-gray-600 hover:text-up247-600 transition-colors">Features</a></li>
                <li><a href="#benefits" className="text-gray-600 hover:text-up247-600 transition-colors">Benefits</a></li>
                <li><a href="#signup" className="text-gray-600 hover:text-up247-600 transition-colors">Sign Up</a></li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-sm font-semibold text-gray-900 mb-4">Company</h3>
              <ul className="space-y-3">
                <li><a href="#" className="text-gray-600 hover:text-up247-600 transition-colors">About</a></li>
                <li>
                  <button 
                    onClick={() => setShowContact(true)}
                    className="text-gray-600 hover:text-up247-600 transition-colors"
                  >
                    Contact
                  </button>
                </li>
              </ul>
            </div>
            
            <div className="col-span-2 md:col-span-1">
              <h3 className="text-sm font-semibold text-gray-900 mb-4">Legal</h3>
              <ul className="space-y-3">
                <li>
                  <button 
                    onClick={() => setShowPrivacy(true)} 
                    className="text-gray-600 hover:text-up247-600 transition-colors"
                  >
                    Privacy Policy
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => setShowTerms(true)} 
                    className="text-gray-600 hover:text-up247-600 transition-colors"
                  >
                    Terms of Service
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-100 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm mb-4 md:mb-0">
            &copy; {new Date().getFullYear()} up247. All rights reserved.
          </p>
          
          <div className="flex space-x-6 items-center">
            <a href="https://twitter.com/up247app" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-up247-600 transition-colors">
              <FaTwitter size={20} />
            </a>
            <a href="https://www.youtube.com/@up247ai" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-up247-600 transition-colors">
              <FaYoutube size={20} />
            </a>
            <button 
              onClick={scrollToTop}
              className="w-10 h-10 rounded-full bg-gray-100 text-gray-600 flex items-center justify-center hover:bg-up247-50 hover:text-up247-600 transition-colors"
              aria-label="Scroll to top"
            >
              <ArrowUp size={18} />
            </button>
          </div>
        </div>
      </div>

      {showPrivacy && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded-lg max-w-3xl w-full relative">
            <button onClick={() => setShowPrivacy(false)} className="absolute top-3 right-3">
              Close
            </button>
            <PrivacyPolicy />
          </div>
        </div>
      )}

      {showTerms && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded-lg max-w-3xl w-full relative">
            <button onClick={() => setShowTerms(false)} className="absolute top-3 right-3">
              Close
            </button>
            <TermsOfService />
          </div>
        </div>
      )}

      {showContact && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg w-full max-w-4xl relative overflow-auto resize-y min-h-[400px] max-h-[90vh]">
            <button 
              onClick={() => setShowContact(false)} 
              className="absolute top-4 right-4 z-10 p-2 hover:bg-gray-100 rounded-full"
              aria-label="Close"
            >
              ✕
            </button>
            <div className="overflow-y-auto h-full p-6">
              <Contact />
            </div>
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;
